import { Box, Collapse, IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { StationItem } from "../../../models/types/station";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useTranslation } from "react-i18next";

const StationGeneral = ({ data, defaultOpen, editUrl }: { data: StationItem; defaultOpen?: boolean; editUrl: string }) => {
    const [open, setOpen] = useState<boolean>(defaultOpen || false);
    const { t } = useTranslation();
    return (
        <div>
            <div className="bg-white rounded-md">
                <Box sx={{ borderRadius: 1, border: "1px solid #cce4ff" }}>
                    <Box
                        className="summary_header"
                        sx={{
                            backgroundColor: "#e3f2fd",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => setOpen(!open)}
                    >
                        <Typography fontWeight="bold">{t("station.view.title")}</Typography>
                        <div className="flex items-center gap-2">
                            <Link
                                to={editUrl}
                                className="flex items-center gap-1 italic text-blue-500 text-sm hover:underline"
                            >
                                <Pencil size={12} />
                                {t("station.view.edit")}
                            </Link>
                            <IconButton size="small">
                                <ExpandMoreIcon
                                    sx={{
                                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                        transition: "transform 0.2s",
                                    }}
                                />
                            </IconButton>
                        </div>
                    </Box>
                    <Collapse in={open}>
                        <Box className="summary_content" sx={{ p: 2 }}>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.stationName")}:</Typography>
                                <Typography fontWeight="bold">{data?.name}</Typography>
                            </Box>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.stationCode")}:</Typography>
                                <Typography fontWeight="bold">{data?.code}</Typography>
                            </Box>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.address")}:</Typography>
                                <Typography fontWeight="bold">{data?.address}</Typography>
                            </Box>
                            <div className="flex gap-2">
                                <Box display="flex" gap={1} mb={1}>
                                    <Typography color="text.secondary">{t("station.view.fields.longitude")}:</Typography>
                                    <Typography fontWeight="bold">{data?.longitude}</Typography>
                                </Box>
                                <span>-</span>
                                <Box display="flex" gap={1} mb={1}>
                                    <Typography color="text.secondary">{t("station.view.fields.latitude")}:</Typography>
                                    <Typography fontWeight="bold">{data?.latitude}</Typography>
                                </Box>
                            </div>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.stationType")}:</Typography>
                                <Typography fontWeight="bold">{data?.type}</Typography>
                            </Box>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.loggerAddress")}:</Typography>
                                <Typography fontWeight="bold">{data?.dataLoggerAddress}</Typography>
                            </Box>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.telegramWarning")}:</Typography>
                                <Typography fontWeight="bold">{data?.telegramWarning}</Typography>
                            </Box>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.smsWarning")}:</Typography>
                                <Typography fontWeight="bold">{data?.smsWarning.join(", ")}</Typography>
                            </Box>
                            <Box display="flex" gap={1} mb={1}>
                                <Typography color="text.secondary">{t("station.view.fields.emailWarning")}:</Typography>
                                <Typography fontWeight="bold">{data?.emailWarning.join(", ")}</Typography>
                            </Box>
                        </Box>
                    </Collapse>
                </Box>
            </div>
        </div>
    );
};

export default StationGeneral;